import { render, staticRenderFns } from "./adminBusinessDepartment.vue?vue&type=template&id=5a9c6f57&scoped=true"
import script from "./adminBusinessDepartment.vue?vue&type=script&lang=js"
export * from "./adminBusinessDepartment.vue?vue&type=script&lang=js"
import style0 from "./adminBusinessDepartment.vue?vue&type=style&index=0&id=5a9c6f57&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9c6f57",
  null
  
)

export default component.exports